import React from 'react'
function InvoiceHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-header-content { display: flex; }
        .content-header-content .caption { flex: 1; }

        #invoice-session-timer {
          padding: 7px;
          margin: auto 0;
          font-size: 0.65em;
          animation: blurring 500ms;
          /*transition: color 800ms ease;*/
          flex: 1;
          color: #202020;
        }
        @keyframes blurring {
          from { opacity: 0 }
          to { opacity: 1 }
        }
        .session-label {
          font-weight: normal;
          font-family: 'Corbel';
        }
        .session-timer {
          font-family: 'OCR A';
          font-weight: bold;
          color: #4040FF;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(InvoiceHeaderStyle)
